import React from 'react'
import "./RecipeTile.css";

export default function RecipeTile({recipe}) {
    return (
        recipe["recipe"]["image"].match(/\.(jpeg|jpg|gif|png)$/)
        != null && (
            <div className="recipeTile">
                <img className="recipeTileImg" src={recipe["recipe"]["image"]} alt="A dish with various food within it." />
                <p className="recipeTileName">{recipe["recipe"]["label"]}</p>
                <a className="recipeTileLink" href={recipe["recipe"]["url"]} target="_blank" rel="noreferrer"> See Recipe! </a>
            </div>
        )
    );
}